import React from "react";
import { useSelector } from "react-redux";

const Loader = () => {
    const siteLoader = useSelector((state) => state.auth.siteLoader);
    if (!siteLoader) return <></>;
    return (
        <div
            className=""
        >
            <div>
                <span className="">Loading...</span>
            </div>
        </div>
    );
};

export default Loader;
